export default __webpack_public_path__ + "static/uni-hamburg-b468a3b3d7e575b3b8f613e32c31b2e7.png";